<template>
  <div class="service-request-page-step__wrapper">
    <div class="service-request-page-step__fields">
      <BaseSelect
        v-model="form.service_id"
        :required="getMain.form.service_id.required"
        :items="serviceItemsLoader()"
        :label="getMain.form.service_id.label"
        :placeholder="getMain.form.service_id.placeholder"
        :errorMsg="errorMsgs.service_id"
        class="service-request-page__form-input"
        :autoSelect="true"
        @input="serviceChange"
        :disabled="queryServiceValid"
        :hideArrow="queryServiceValid"
      />
      <BaseSelect
        v-if="serviceSubItemsPrepared.length"
        v-model="form.sub_service_id"
        :required="true"
        :items="serviceSubItemsPrepared"
        :label="getMain.form.sub_service_id.label"
        :placeholder="getMain.form.sub_service_id.placeholder"
        :errorMsg="errorMsgs.sub_service_id"
        class="service-request-page__form-input"
        :autoSelect="true"
      />
      <BaseDatePicker
        ref="datePicker"
        :label="getMain.form.date_time.label"
        :required="getMain.form.date_time.required"
        :buttonsText="getMain.form.date_time.buttonText"
        :options="datePickerOptions"
        :errorMsg="errorMsgs.date_time"
        :class="['service-request-page__form-input']"
        :requestServiceIn="requestServiceIn"
        :workPeriod="workPeriod"
        :globalTime="time"
        :changeTime="changeTime"
        @input="form.date_time = $event"
      />
      <BaseSelect
        v-model="form.mobility_id"
        :items="moboiltiesItems"
        :label="getMain.form.mobility_id.label"
        :placeholder="getMain.form.mobility_id.placeholder"
        :required="getMain.form.mobility_id.required"
        :errorMsg="errorMsgs.mobility_id"
        :autoSelect="true"
        class="service-request-page__form-input-mobility"
      />
    </div>
    <div v-if="getMain.hintText" class="service-request-page__editor-wrapper">
      <p class="service-request-page__editor" v-html="getMain.hintText" />
    </div>
    <BaseButton
      class="service-request-page__button"
      type="primary"
      :disabled="!serviceSubItemsPrepared.length ? (!form.service_id || !form.date_time || !form.mobility_id) :(!form.service_id || !form.date_time || !form.mobility_id || !form.sub_service_id) "
      @click="submitForm"
    >
      {{ getMain.continueButtonText }}
      <IconArrow class="icon-left" />
    </BaseButton>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'

  export default {
    name: 'Step2',

    components: { IconArrow },
    props: {
      form: [Object, String],
      dealerItems: Array,
      title: String,
      hint: String,
      showroom: String,
      errorMsgs: Object,
      submitForm: Function,
      requestServiceIn: Number,
      workPeriod: [Function, Object],
      time: String,
      changeTime: Function,
      moboiltiesItems: Array,
      dealerServices: Array,
      currentStepIndex: Number,
      onServiceChanged: Function
    },
    data () {
      return {
        error: false,
        language: this.$store.state.currentLang,
        country: this.$store.state.currentCountry
      }
    },
    computed: {
    ...mapGetters(['getMain', 'isShow', 'getPhoneType']),
    ...mapState({
      currentLang: state => state.currentLang,
      currentCountry: state => state.currentCountry
    }),
      queryService () {
        return this.$route.query.service
      },

      queryServiceValid () {
        if (!this.queryService) return false

        return this.serviceItems.some(
          item => String(item.value) === String(this.queryService)
        )
      },
      serviceItems () {
        let items = (this.getMain && this.getMain.form.service_id.items) || []

        if (!this.dealerServices || !this.dealerServices.length) return items

        const dealerServiceIds = this.dealerServices.map(s => s.id)

        items = items.filter(item => dealerServiceIds.includes(item.value))

        return items
      },
      subServiceItems () {
        const items = (this.getMain && this.getMain.form.sub_service_id.items) || []

        if (!this.dealerServices || !this.dealerServices.length) return []

        const service = this.dealerServices.find(
          el => el.id === this.form.service_id
        )

        if (!service || !service.subServices) return []

        const lang = this.currentLang || 'ru'

        // мапа сабсервисов по id
        const subServicesMap = new Map(
          service.subServices.map(s => [s.id, s])
        )

        const filteredItems = items
          .filter(item => subServicesMap.has(+item.value))
          .map(item => {
            const subService = subServicesMap.get(+item.value)

            return {
              ...item,
              label:
                subService[`label_${lang}`]
            }
          })

        return filteredItems
      },
      datePickerOptions () {
        const dealerId = this.form.dealer_id
        let items = this.getMain.form.date_time.options

        this.dealerItems.forEach(({ value, workPeriod }) => {
          if (value === dealerId) {
            items = { datePickerStep: 60, schedule: workPeriod }
          }
        })
        return items
      },
      serviceSubItemsPrepared () {
        return this.subServiceItems.map(item => ({
          ...item,
          text: item.label
        }))
      }
    },
    methods: {
      serviceItemsLoader () {
        return this.serviceItems.map(item => (
          {
          ...item,
          text: item.label
          }
        ))
      },
      serviceChange () {
        this.form.sub_service_id = ''
        this.onServiceChanged()
      }
    }
  }
</script>

<style lang="scss">
.service-request-page-step {
  &__fields{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(255px, 1fr));
    gap: 24px;
    margin-bottom: 24px;
    .select{
      margin-bottom: 0!important;
      min-width: unset;
    }
    .datepicker{
      min-width: unset;
    }
    @media (max-width: 1200px) {
      grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 1024px) {
      grid-template-columns: 1fr;
      gap: 16px;
      margin-bottom: 16px;
    }
  }
}
</style>
